import Vue from 'vue'
import Router from 'vue-router'

// Dashboard Components
const dashboard = () => import("@/views/dashboard");
import BaseContainer from '../BaseContainer'
//  Pages
import error404 from '../views/pages/error-404'
import error500 from '../views/pages/error-500'
const login = () => import("@/views/pages/login");
const forgotpassword  = () => import("@/views/pages/forgotpassword");
const users = () => import("@/views/pages/users");
const adminusers = () => import("@/views/pages/adminusers");
const roles = () => import("@/views/pages/roles");
const resetpassword = () => import("@/views/pages/resetpassword");
const register = () => import("@/views/pages/register");
const activateuser = () => import("@/views/pages/activateuser");
const addrole = () => import("@/views/pages/addrole");
const adduser = () => import("@/views/pages/adduser");
const changepassword = () => import("@/views/pages/changepassword");
const getuser = () => import("@/views/pages/userdetail");
const updateprofile = () => import("@/views/pages/updateprofile");
const configuration = () => import("@/views/pages/configuration");
const updateconfiguration = () => import("@/views/pages/updateconfiguration");
const fuelcapacity = () => import("@/views/pages/fueltankcapacity");
const createfuelcapacity = () => import("@/views/pages/addfuelcapacity");

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: "/login",
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/activateuser',
      name: 'activateuser',
      component: activateuser,
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: forgotpassword
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: resetpassword
    },
    {
      path: '/404',
      name: 'error-404',
      component: error404,
    },
    {
      path: '/500',
      name: 'error-500',
      component: error500,
    },
    {
      path: "/",
      component: BaseContainer,
      children: [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/config',
    name: 'Configuration',
    component: configuration,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/config/update',
    name: 'updateConfiguration',
    component: updateconfiguration,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/fuel/capacity',
    name: 'fuelcapacity',
    component: fuelcapacity,
    meta: {
      requiresAuth: true
    },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children:[
      {
        path: '/fuel/capacity',
        name: 'fuelcapacity',
        component: fuelcapacity,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/fuel/capacity/create',
        name: 'createfuelcapacity',
        component: createfuelcapacity,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/fuel/capacity/:id',
        name: 'editfuelcapacity',
        component: createfuelcapacity,
        meta: {
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/users',
    name: 'users',
    meta: {
      requiresAuth: true
    },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children:[
      {
        path: '/users',
        name: 'users',
        component: users,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/user/create',
        name: 'adduser',
        component: adduser,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/user/profile',
        name: 'updateprofile',
        component: updateprofile,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/user/create/:id',
        name: 'edituser',
        component: adduser,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/user/detail/:id',
        name: 'getuser',
        component: getuser,
        meta: {
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/roles',
    name: 'roles',
    meta: {
      requiresAuth: true
    },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children:[
      {
        path: '/roles',
        name: 'roles',
        component: roles,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/roles/create',
        name: 'addrole',
        component: addrole,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/roles/create/:id',
        name: 'editrole',
        component: addrole,
        meta: {
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/password/reset',
    name: 'changepassword',
    component: changepassword,
    meta: {
      requiresAuth: true
    }
  },{
    path: '/admin/users',
    name: 'adminusers',
    component: adminusers,
    meta: {
      requiresAuth: true
    }
  },
  ]}]
})
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth == true) {
    if (localStorage.getItem("userToken") == null) {
      next({ name: "login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js